export default __webpack_public_path__ + "static/media/logo.42853872.svg";